"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const classnames_1 = __importDefault(require("classnames"));
const react_1 = __importDefault(require("react"));
const SocialMediaLinks_1 = __importDefault(require("../constants/SocialMediaLinks"));
const SocialMedia = () => (react_1.default.createElement("div", { className: "znd-social-media" }, SocialMediaLinks_1.default.map((item, key) => {
    return (react_1.default.createElement("a", { key: key, className: (0, classnames_1.default)('znd-social-media__link', item.icon), href: item.url, target: "_blank", rel: "noreferrer", title: item.title }));
})));
exports.default = SocialMedia;
